import { render, staticRenderFns } from "./EditActivitiesDialog.vue?vue&type=template&id=6681eb20&scoped=true&"
import script from "./EditActivitiesDialog.vue?vue&type=script&lang=js&"
export * from "./EditActivitiesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6681eb20",
  null
  
)

export default component.exports